import { z } from 'zod'

/**
 * How a tree's coordinate came to be what it is. Mirrors `PositionSource` in
 * prisma/schema.prisma.
 *
 * Worth a column because the two are not equally trustworthy. A GPS fix taken
 * under a canopy — exactly where a surveyor stands — can be 15 m out, while a
 * pin a person dragged onto the visible crown is as accurate as the imagery
 * beneath it. Recording which is which is what makes "show me the pins that
 * still need checking by eye" answerable.
 */
export const POSITION_SOURCES = ['GPS', 'MANUAL'] as const

export const positionSourceSchema = z.enum(POSITION_SOURCES)

export type PositionSource = z.infer<typeof positionSourceSchema>
